module.exports = __webpack_public_path__ + "de-5FD.svg";